import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FamilyService } from '@app/services/family/family.service';
import { ProductService } from '@app/services/product/product.service';
import { OrdersService } from '@app/services/order/orders.service';

@Component({
    selector: 'carte-family',
    templateUrl: 'carte-family.component.html',
    styleUrls: ['carte-family.component.scss']
})
export class CarteFamilyComponent {
    @ViewChild('template') template: ElementRef;
    family: any = {};
    families: any[] = [];
    products: any[] = [];
    chosenOrderType: number;
    bsModalRef: BsModalRef;
    subscriptions2: Subscription[] = [];
    orderType;
    compositions: any[] = [];
    itemsCompositions: any[] = [];
    selectedComp: any[] = [];
    productsCSC: any[] = [];
    productsAc: any[] = [];
    loadProducts = true;
    orderProg;
    constructor(
        private familyService: FamilyService,
        private route: ActivatedRoute,
        private productService: ProductService,
        private orderService: OrdersService,
        private router: Router,
    ) {
        const subs3 = this.orderService.orderType.subscribe((orderType: number) => {
            this.orderType = orderType;
        });
        const subs1 = this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        const subs2 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.chosenOrderType > 0) {
                this.orderType = chosenOrderType;
            }
            this.getElements()
        });
        this.subscriptions2.push(subs1, subs2, subs3);
    }

    ngOnInit() {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.products = [];
                this.loadProducts = true;
            }
        })
    }

    getElements() {
        if (this.families.length == 0) {
            this.familyService.families.subscribe(
                (families: any[]) => {
                    if (families.length > 0) {
                        this.families = families
                        this.route.params.subscribe(params => {
                            if (params['family']) {
                                let index = this.families.findIndex(f => f.slug == params['family']);
                                if (index > -1) {
                                    this.family = this.families[index];
                                    this.getProducts();
                                } else {
                                    this.router.navigate(["/modes"]);
                                }
                            }
                        })
                    }
                })
        } else {
            this.getProducts();
        }
    }

    getProducts() {
        return this.productService.getActiveProductByFamily(this.family.id, this.orderType, this.orderProg).toPromise().then(
            (data: any[]) => {
                this.loadProducts = false;
                this.products = data;
            }
        );
    }

    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy() {
        this.unsubscribe2();
    }
}
